module.exports = __webpack_public_path__ + "img/1.5c46b7f4.png";